import { Alert } from "reactstrap";

export const CustomToast = ({ appearance, children }) => (
    <Alert className={"custom-toast"} color={appearance}>
      {children}
    </Alert>
  );